import { getProfileHistory } from "@actions/profile";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import NoContent from "../../components/NoContent";
import GameContent from "./components/GameContent";
import PaymentContent from "./components/PaymentContent";
import PendingWithdrawContent from "./components/PendingWithdrawContent";
import { ContentWrapper } from "./elements";

const HistoryContent = ({ values, getProfileHistory, translate }) => {
	const [requestParameters, setRequestParameters] = useState({
		startDate: values.dateRange[0] || moment().days(-1),
		endDate: values.dateRange[1] || moment(),
		size: 30,
		lastItem: 0,
		filters: {
			paymentType: "All",
		},
	});

	const [responses, setResponses] = useState({
		gameContentResponse: {
			count: 0,
			reports: [],
			lastItem: 0,
		},
		paymentContentResponse: {
			count: 0,
			reports: [],
			lastItem: 0,
		},
		pendingWithdrawContentResponse: {
			count: 0,
			reports: [],
			lastItem: 0,
		},
	});

	const fetchHistories = () => {
		let payload = {
			startDate: moment(values.dateRange[0]).valueOf(),
			endDate: moment(values.dateRange[1]).valueOf(),
			size: 30,
		};

		if (requestParameters.lastItem > 0) {
			payload.lastItem = requestParameters.lastItem;
			payload.size = 30;
		}

		getProfileHistory(
			values.type,
			payload,
			requestParameters.filters.paymentType,
			false,
			(response) => {
				let responseKey;
				switch (values.type) {
					case "game":
						responseKey = "gameContentResponse";
						break;
					case "deposit" || "withdraw":
						responseKey = "paymentContentResponse";
						break;
					case "pending_withdraw":
						responseKey = "pendingWithdrawContentResponse";
						break;
					default:
						break;
				}

				if (responseKey) {
					setResponses((prevResponses) => ({
						...prevResponses,
						[responseKey]: {
							...response,
							reports: [...response.reports],
						},
					}));
				}

				if (response.lastItem) {
					setRequestParameters({ ...requestParameters, lastItem: response.lastItem });
				}
			}
		);
	};

	useEffect(() => {
		setResponses({
			gameContentResponse: {
				count: 0,
				reports: [],
				lastItem: 0,
			},
			paymentContentResponse: {
				count: 0,
				reports: [],
				lastItem: 0,
			},
			pendingWithdrawContentResponse: {
				count: 0,
				reports: [],
				lastItem: 0,
			},
		});
	}, [values.dateRange, values.type]);

	useEffect(() => {
		fetchHistories();
	}, [values, requestParameters.lastItem]);

	const renderContents = () => {
		switch (values.type) {
			case "game":
				return (
					<GameContent
						translate={translate}
						data={responses.gameContentResponse}
					/>
				);
			case "deposit" || "withdraw":
				return (
					<PaymentContent
						translate={translate}
						data={responses.paymentContentResponse}
					/>
				);
			case "pending_withdraw":
				return (
					<PendingWithdrawContent
						translate={translate}
						data={responses.pendingWithdrawContentResponse}
						paymentData={responses.paymentContentResponse}
					/>
				);
			default:
				return (
					<NoContent
						translate={translate}
						title={"NoInfoText"}
						description={"NoInfoDesc"}
						noBackground
					/>
				);
		}
	};

	let responseKey;
	switch (values.type) {
		case "game":
			responseKey = "gameContentResponse";
			break;
		case "deposit" || "withdraw":
			responseKey = "paymentContentResponse";
			break;
		case "pending_withdraw":
			responseKey = "pendingWithdrawContentResponse";
			break;
		default:
			break;
	}

	return responses[responseKey]?.reports?.length > 0 ? (
		<ContentWrapper>{renderContents()}</ContentWrapper>
	) : (
		<NoContent
			translate={translate}
			title={"NoInfoText"}
			description={"NoInfoDesc"}
			noBackground
		/>
	);
};

const mapDispatchToProps = {
	getProfileHistory,
};

export default connect(null, mapDispatchToProps)(HistoryContent);
